import React from "react";
import "./Footer.css";

const SubFooter = () => {
  return (
    <div className="sub-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>
              Copyright &copy; 2025 Dreehaan Consultants. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubFooter;
